import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { StyledMenuLink } from '../../components/StyledMenuLink';
import { Device } from '../../constants/device';
import { AppLanguage } from '../../model/enums/AppLanguage';
import { appTranslations } from '../index';
import { useAppContext } from '../../state/StateProvider';

const StyledLanguageSwitcher = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;

  ${StyledMenuLink} {
    font-weight: 400;
    border-bottom: 1px solid;
    padding: 0;

    ${Device.desktop} {
      border-bottom: none;
    }
  }
`;

export const LanguageSwitcher: React.FC = () => {
  const { locale } = useIntl();
  const { pathname, search } = useLocation();
  const { messages } = useIntl();
  const {
    state: { sourceBranch },
  } = useAppContext();

  const getMatchingRoute = (language: string) => {
    /**
     * Get the key of the route the user is currently on
     */
    const route = pathname.substring(3); // remove local part '/en' from the pathname /en/contact
    const routeKey = Object.keys(messages).find((key) => messages[key] === route);

    /**
     * Find the matching route for the new language
     */
    const matchingRoute = routeKey ? appTranslations[language][routeKey] : '';

    /**
     * Add source query if it is set and return localized route
     */

    if (new URLSearchParams(search).has('source')) {
      return `/${language}` + matchingRoute + `?source=${sourceBranch}`;
    }
    return `/${language}` + matchingRoute;
  };

  const getLabel = (language: AppLanguage) => {
    switch (language) {
      case AppLanguage.Czech:
        return 'Čeština';
      case AppLanguage.English:
        return 'English';
      default:
        return '';
    }
  };

  return (
    <StyledLanguageSwitcher>
      {Object.values(AppLanguage).map((lang: string) => {
        if (lang === locale) {
          return null;
        }
        return (
          <li key={lang}>
            <StyledMenuLink as={Link} to={getMatchingRoute(lang)}>
              {getLabel(lang as AppLanguage)}
            </StyledMenuLink>
          </li>
        );
      })}
    </StyledLanguageSwitcher>
  );
};
